import FieldsPayStubStartNew from './FieldsPayStubStartNew'

export default FieldsPayStubStartNew
